// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"42":"ff20abead6c20696","308":"f8c4fbb948a08dd3","521":"4248ac4fc7fc3fe1"}[chunkId] + ".css";
};